import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, Partners, Banner, PortfolioSection } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <Services />
        <Banner />
        <Team />
        <Testimonials />
        <PortfolioSection />
        <Partners />

      </section>

    </>
  );
}

export default AboutUs;